import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useContext, createContext } from 'react';
import { jsx } from '@emotion/react';

var _excluded = ["to"];
function scrollToTarget(targetId) {
  var _document$querySelect;
  (_document$querySelect = document.querySelector("#".concat(targetId))) === null || _document$querySelect === void 0 || _document$querySelect.scrollIntoView({
    block: 'center',
    behavior: 'smooth'
  });
}
var initialLinkContextValue = {
  element: function element(_ref) {
    var to = _ref.to,
      props = _objectWithoutProperties(_ref, _excluded);
    return jsx("a", _extends({
      href: typeof to === 'string' ? to : undefined
    }, props));
  },
  callbacks: {
    onClick: scrollToTarget
  }
};
var LinkContext = /*#__PURE__*/createContext(initialLinkContextValue);
var useLinkContext = function useLinkContext() {
  return useContext(LinkContext);
};
function LinkContextProvider(_ref2) {
  var children = _ref2.children,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? initialLinkContextValue : _ref2$value;
  return jsx(LinkContext.Provider, {
    value: value
  }, children);
}

export { LinkContextProvider, initialLinkContextValue, useLinkContext };
//# sourceMappingURL=LinkContext.js.map
